module.exports = __webpack_public_path__ + "img/process.89268fe2.png";